import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { logout } from '../../../hooks/logout';
import PermissionDenied from '../../common/permissionDenied';
import { ChevronLeft, CircleX, Send, Upload, } from 'lucide-react';
import '../support.scss'
import PropTypes from 'prop-types';
import moment from 'moment';
import { useGetSingleTicketList, useSupportTicket, useSupportTicketStatus } from '../api/supportapi';
import { queryClient } from '../../../config';
import { useCheckAdminAccess } from '../../WhiteIp/api/whiteipapi';
import { useToast } from '../../../hooks/usetoast';
import { WaitingLoader } from '../../../hooks/buttonLoad';
import Swal from 'sweetalert2';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';

function TicketChat({ toggleDrawer }) {
    const navigate = useNavigate();
    const { id, hashId } = useParams();
    const fileInputRef = useRef(null);
    const { data: getsupportlist, isLoading } = useGetSingleTicketList({ id });
    const updateTicketStatus = useSupportTicketStatus()

    const updateMessagge = useSupportTicket();

    const [adminReply, setAdminReply] = useState('');
    const [selectedImageFile, setSelectedImageFile] = useState(null);
    const [loading, setLoading] = useState(null);



    const handleReplyChange = (event) => {
        setAdminReply(event.target.value);
    };

    const toast = useToast()


    const handleReplySubmit = async (event) => {
        event.preventDefault();

        if (!adminReply.trim() && !selectedImageFile) return;
        setLoading(true)
        const formData = new FormData();
        formData.append('ticketId', hashId);
        formData.append('comment', adminReply.trim());
        formData.append('image', selectedImageFile || '');



        try {
            const updateSupport = await updateMessagge.mutateAsync(formData);
            if (updateSupport.status) {
                queryClient?.refetchQueries('single-detail');
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            toast.error('Failed to submit reply');
            setLoading(false)

        } finally {
            setAdminReply('');
            setSelectedImageFile(null);
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
            setLoading(false)

        }
    };

    const checkAdminMutation = useCheckAdminAccess();
    const [access, setAccess] = useState(true);

    const chatMessagesRef = useRef();
    useEffect(() => {
        if (chatMessagesRef.current) {
            chatMessagesRef.current.scrollTo(0, chatMessagesRef.current.scrollHeight);
        }
    }, [getsupportlist?.data?.data?.support]);

    useEffect(() => {
        checkAdminAccess();
    }, [access]);

    const checkAdminAccess = async () => {
        const obj = {
            page: "Support Ticket"
        }
        setLoading(true)

        const checkAdminRes = await checkAdminMutation.mutateAsync(obj)
        if (checkAdminRes.status === true) {
            if (checkAdminRes.role === "all") {
                setAccess(true);
            } else {
                setAccess(checkAdminRes.otherData);
            }
        } else if (checkAdminRes.statusCode === 440) {
            logout();
        }
        setLoading(false)

    };

    const readFileAsync1 = (file) => {
        return new Promise((resolve, reject) => {
            if (!file) {
                return;
            }
            const reader = new FileReader();
            reader.onload = () => {
                const base64Data = btoa(reader.result);
                resolve(`data:${file.type};base64,${base64Data}`);
            };
            reader.onerror = reject;
            reader.readAsArrayBuffer(file);
        });
    }



    const handleProfile = async (event) => {
        const img = event.target.files[0];
        if (!img) return;

        const reader = new FileReader();
        reader.onload = (event) => {
            const imgCheck = new Image();
            imgCheck.src = event.target.result;
            imgCheck.onload = async () => {
                if (imgCheck.width <= 6000 && imgCheck.height <= 6000) {
                    if (img.size < 2 * 1024 * 1024) {
                        try {
                            await readFileAsync1(img);
                            setSelectedImageFile(img);
                        } catch (error) {
                            console.error('Error reading file:', error);
                            toast.error('Failed to process image');
                        }
                    } else {
                        toast.error('Image size must be less than 2MB');
                    }
                } else {
                    toast.error('Image dimensions must be 6000x6000 pixels or less');
                }
            };
            imgCheck.onerror = () => {
                toast.error('Invalid image file');
            };
        };
        reader.onerror = () => {
            toast.error('Error reading image file');
        };
        reader.readAsDataURL(img);
    };

    const handleClose = (id, status) => {
        Swal.fire({
            title: "Are you sure you want to Close the Ticket?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, Close it!"
        }).then(async (result) => {

            if (result.isConfirmed) {

                try {
                    setLoading(true);

                    const res = await updateTicketStatus.mutateAsync({
                        ticketId: id,
                        status

                    });

                    if (!res?.data?.status) {
                        setLoading(false);
                        return toast.error(res?.data?.message);
                    }

                    setLoading(false);
                    Swal.fire({
                        title: "Close Ticket!",
                        text: "This Ticket has been Closed.",
                        icon: "success"
                    });

                    navigate('/support')

                } catch (error) {
                    setLoading(false);
                }
            }
        });
    }

    function getStatusColor(status) {
        if (status === "Closed") return "red";
        else if (status === "pending") return "orange";
        else return "green";
    }

    return (
        <div className="chat-container">
            {access ? (
                <>
                    {
                        isLoading || loading && <WaitingLoader />
                    }
                    <div className=' d-flex justify-content-between'>
                        <div className=' mb-3'>
                            <h5 className="">
                                <ChevronLeft size={18} className="me-2" style={{ cursor: "pointer" }} onClick={() => navigate('/support')} />
                                Ticket ID: <span className=' fw-bold'>#{hashId}</span></h5>
                            <p className=' ms-4 mt-1'>Category: {getsupportlist?.data?.data?.category}</p>




                            <p className="ms-4 mt-2">
                                Status: <span style={{ color: getStatusColor(getsupportlist?.data?.data?.status) }}>
                                    {getsupportlist?.data?.data?.status}
                                </span>
                            </p>


                            <p className='ms-4 mt-2'>Subject: {getsupportlist?.data?.data?.subject}</p>
                        </div>
                        {getsupportlist?.data?.data?.status !== "Closed" &&
                            <div className=' align-content-end me-2 mb-2'>
                                <button className='btn btn-primary d-flex align-items-center'
                                    onClick={() => handleClose(hashId, "Closed")}
                                >
                                    <CircleX size={20} style={{ marginRight: "2px" }} /> Close Ticket
                                </button>
                            </div>
                        }

                    </div>


                    <div className="ad_pg_bx bg-white p-4" style={{ height: '580px', overflowY: 'auto', display: 'flex', flexDirection: 'column', border: '1px solid #d1d1d1', borderRadius: '8px' }} ref={chatMessagesRef}>
                        <div className="message">



                            {getsupportlist?.data?.data?.support.map((row, i) => {
                                const senderName = row.sender === "user"
                                    ? getsupportlist?.data?.data?.userId?.userName
                                    : row.sender.charAt(0).toUpperCase() + row.sender.slice(1);

                                return (
                                    <div key={row.id || i} className={`message-container ${row.sender}`}>
                                        <div className="reply">
                                            <span className="username fw-bold">{senderName}</span>: {row.comments}
                                            <p className='mt-2'>{moment(row?.createdAt).format("DD-MM-YYYY | hh:mm A")}</p>


                                            {
                                                senderName !== "Admin" ?
                                                    <>

                                                        {row?.images?.length > 0 && (
                                                            <div className="image-container mt-2">
                                                                <PhotoProvider>
                                                                    {row.images.map((imgUrl, idx) => (
                                                                        <div key={imgUrl.comment}>
                                                                            <PhotoView src={imgUrl.url}>
                                                                                <img
                                                                                    src={imgUrl.url}
                                                                                    alt={`Attachment ${idx + 1}`}
                                                                                    className="support-image ms-3"
                                                                                    width="150px"
                                                                                    style={{ cursor: 'pointer' }}
                                                                                />
                                                                            </PhotoView>
                                                                            <p className="ms-4 mt-3">{imgUrl.comment}</p>
                                                                        </div>
                                                                    ))}
                                                                </PhotoProvider>
                                                            </div>
                                                        )}
                                                    </> :

                                                    <>

                                                        {row?.images?.length > 0 && (
                                                            <div className="image-container mt-2">
                                                                <PhotoProvider>
                                                                    {row.images.map((imgObj, idx) => (
                                                                        <div key={imgObj.comment}>
                                                                            <PhotoView src={imgObj.url}>
                                                                                <img
                                                                                    src={imgObj.url}
                                                                                    alt={`Attachment ${idx + 1}`}
                                                                                    className="support-image ms-3"
                                                                                    width="150px"
                                                                                    style={{ cursor: 'pointer' }}
                                                                                />
                                                                            </PhotoView>
                                                                            <p className="ms-4 mt-3">{imgObj.comment}</p>
                                                                        </div>
                                                                    ))}
                                                                </PhotoProvider>
                                                            </div>
                                                        )}

                                                    </>
                                            }

                                        </div>
                                    </div>
                                );
                            })}

                        </div>
                    </div>
                    <form onSubmit={handleReplySubmit} className="admin-reply-form"
                        style={{
                            position: 'sticky',
                            bottom: '0',
                            width: '100%',
                            zIndex: 10,
                        }}>



                        {getsupportlist?.data?.data?.status !== "Closed" &&

                            <div className="tkDtBxFt ">
                                <div className="input-group" style={{
                                    display: 'flex',

                                }}>

                                    <label htmlFor="imageUpload" style={{ cursor: 'pointer' }}>
                                        <Upload color="#555353" size={25} />
                                    </label>
                                    <input
                                        id="imageUpload"
                                        type="file"
                                        accept="image/*"
                                        style={{ display: 'none' }}
                                        ref={fileInputRef}
                                        onChange={handleProfile}
                                    />

                                    {selectedImageFile && (
                                        <div style={{ position: 'relative', marginLeft: '30px', marginBottom: '10px' }}>
                                            <img
                                                src={URL.createObjectURL(selectedImageFile)}
                                                alt="Preview"
                                                style={{ width: '50px', objectFit: 'contain' }}
                                            />
                                            <button

                                                onClick={() => {
                                                    setSelectedImageFile(null);
                                                    if (fileInputRef.current) {
                                                        fileInputRef.current.value = '';
                                                    }
                                                }}
                                                style={{
                                                    position: 'absolute',
                                                    top: '-8px',
                                                    right: '-8px',
                                                    background: '#f44336',
                                                    color: 'white',
                                                    border: 'none',
                                                    borderRadius: '50%',
                                                    width: '20px',
                                                    height: '20px',
                                                    cursor: 'pointer',
                                                    fontSize: '14px',
                                                    lineHeight: '20px',
                                                    textAlign: 'center',
                                                    padding: 0
                                                }}
                                            >
                                                ×
                                            </button>
                                        </div>
                                    )}


                                    <textarea
                                        value={adminReply}
                                        onChange={handleReplyChange}
                                        className="form-control ml-5"
                                        placeholder="Type your reply here..."
                                        rows="3"
                                        style={{
                                            width: '80%',
                                            marginRight: '10px',
                                            marginLeft: selectedImageFile ? '50px' : '30px',
                                            marginTop: "40px"
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                                handleReplySubmit(e);
                                            }
                                        }}
                                    />

                                    <button className="btn" type="submit"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleReplySubmit(e);
                                        }}>
                                        <Send color='#555353' size={25} />
                                    </button>
                                </div>
                            </div>

                        }

                    </form>

                </>
            ) : (
                <PermissionDenied />
            )
            }
        </div >
    );
}

TicketChat.propTypes = {
    toggleDrawer: PropTypes.any,
};

export default TicketChat;
